import PageRenderer from "../components/PageRenderer";

const Spendenempfaenger = () => (
    <PageRenderer pageName="Spendenempfaenger" analyticsPath="/spendenempfaenger" />
);

export default Spendenempfaenger;
